module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('span', {
    staticClass: "tabs-banners",
    class: _vm.notiType === 'banner' ? 'selected' : '',
    on: {
      "click": function($event) {
        _vm.notiType = 'banner'
      }
    }
  }, [_vm._v("Banners")]), _vm._v(" "), _c('span', {
    staticClass: "tabs-flags",
    class: _vm.notiType === 'flag' ? 'selected' : '',
    on: {
      "click": function($event) {
        _vm.notiType = 'flag'
      }
    }
  }, [_vm._v("Flag messages")]), _vm._v(" "), _c('span', {
    staticClass: "tabs-inlines",
    class: _vm.notiType === 'inline' ? 'selected' : '',
    on: {
      "click": function($event) {
        _vm.notiType = 'inline'
      }
    }
  }, [_vm._v("Inline messages")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notiType === 'banner'),
      expression: "notiType === 'banner'"
    }]
  }, [_c('notifcation-banner')], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notiType === 'flag'),
      expression: "notiType === 'flag'"
    }]
  }, [_c('notifcation-flag')], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notiType === 'inline'),
      expression: "notiType === 'inline'"
    }]
  }, [_c('notifcation-inline')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "header-wrapper"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h1', [_vm._v("Notification")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61d8dfb3","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notification.vue
// module id = CTAe
// module chunks = 0